export default __webpack_public_path__ + "static/media/KE.7a93d3a6.svg";